import video from '../common/config/video'

export default (roomId: string, roomKey: string, participantKey: string, redirectTo?: string): string => {
  return `${video.videoURL}?roomId=${roomId}&roomKey=${roomKey}&participantKey=${participantKey}&redirectTo=${redirectTo}`
}
